import { QueryConfig } from 'pg';

import PostgresClient, { DEFAULT_POSTGRES_CLIENT } from '../../shared/postgres';
import DateUtils from '../../util/date';

import { CHECKS_SCHEMA } from './schema';
import { GetMonitorChecksParams } from './types';

export interface MonitorCheckDatasource {
  getMonitorChecks: <T>(params: GetMonitorChecksParams) => Promise<T[]>;
}

abstract class AbstractTimescaleMonitorCheckDatasource implements MonitorCheckDatasource {
  protected readonly client: PostgresClient;

  public constructor(client: PostgresClient = DEFAULT_POSTGRES_CLIENT) {
    this.client = client;
  }

  public getMonitorChecks = <T>(params: GetMonitorChecksParams): Promise<T[]> => {
    const queryConfig = this.getMonitorChecksQueryConfig(params);
    return this.client.query(queryConfig).then(resp => {
      const rows = resp.rows as T[];
      return rows;
    });
  };

  private getMonitorChecksQueryConfig = ({
    monitorId,
    pagination = {},
    timeFilter,
    tableName,
  }: GetMonitorChecksParams): QueryConfig => {
    let rawSQL = `SELECT * FROM ${CHECKS_SCHEMA}.${tableName} WHERE ${CHECKS_SCHEMA}.${tableName}.monitor_id = $1 `;
    if (timeFilter) {
      const { from, to } = timeFilter;
      rawSQL = `${rawSQL} AND ${CHECKS_SCHEMA}.${tableName}.time BETWEEN '${DateUtils.toDatetime(
        from
      )}'::timestamp AND ${to ? `'${DateUtils.toDatetime(to)}'` : 'now()'}::timestamp `;
    }

    rawSQL = `${rawSQL} ORDER BY time DESC LIMIT $2 OFFSET $3`;

    const { limit, offset = 0 } = pagination;
    return {
      text: rawSQL,
      values: [monitorId, limit, offset],
    };
  };
}

export default AbstractTimescaleMonitorCheckDatasource;
